import React, {useContext} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import './Menu.scss';
import {I18nContext} from "../contexts/i18nContext";
import {AuthContext} from "../contexts/authContext";
import CloseIcon from '@mui/icons-material/Close';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ChatIcon from '@mui/icons-material/Chat';
import LogoutIcon from '@mui/icons-material/Logout';
import FeedbackIcon from '@mui/icons-material/Feedback';
import {getCurrentUserRole} from "../helpers/helpers";

const Menu = ({showMenu, close, toggleFeedbackModal}) => {
  const { t } = useContext(I18nContext);
  const { logOut } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const userRole = getCurrentUserRole();

  const menuItems = [
    {name: t('projects'), path: '/', icon: <FlashOnIcon />},
    {name: t('planning'), path: '/planning', icon: <EditCalendarIcon />},
    {name: t('profile'), path: '/profile', icon: <PersonIcon />},
    {name: t('selections'), path: '/selections', icon: <ListAltIcon />},
    {name: t('admin panel'), path: '/admin', icon: <SettingsIcon />, hidden: userRole !== 'ADMIN'},
    {name: t('feedback'), path: '/feedback', icon: <ChatIcon />, hidden: userRole !== 'ADMIN'},
  ];

  const handleLogout = () => {
    logOut();
    navigate('/login');
  };

  const handleClick = (option) => {
    navigate(option);
    close();
  };

  return (
    <div className={showMenu ? 'MenuActive' : 'Menu'}>

      <div className='closeButton' onClick={close}>
        <CloseIcon />
      </div>


      <ul className='menuItemsList'>
        {menuItems.filter(item => !item.hidden).map((item, index) => (
          <li
            key={index}
            className={location.pathname === item.path ? 'menuItemActive' : 'menuItem'}
            onClick={() => handleClick(item.path)}
          >
            <div className='iconWrapper'>
              {item.icon}
            </div>
            {item.name}
          </li>
        ))}
        <li className='menuItem' onClick={handleLogout}>
          <div className='iconWrapper'>
            {<LogoutIcon />}
          </div>
          {t('log out')}
        </li>
      </ul>

      <div className='feedbackItem' onClick={toggleFeedbackModal}>
        <div className='iconWrapper'>
          <FeedbackIcon />
        </div>
        {t('give us your feedback regarding the system performance')}
      </div>
    </div>
  );
};

export default Menu;
